import { useI18n } from "@/i18n/I18nProvider";

export const Contact = () => {
  const { t } = useI18n();

  return (
    <section id="contact">
      <div className="container py-20">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <h2 className="font-display text-4xl md:text-5xl font-black text-gradient-contact">
            {t("contact.title")}
          </h2>
          <p className="text-gradient text-lg md:text-xl max-w-2xl mx-auto">
            {t("contact.subtitle")}
          </p>
          <div className="pt-4 space-y-2">
            <p className="text-xs font-black uppercase tracking-[0.15em] text-gradient-contact">
              {t("contact.mainLabel")}
            </p>
            <a
              href="mailto:supremecommerceltd@gmail.com"
              className="inline-block font-display text-2xl md:text-3xl font-black text-neon-purple hover:text-neon-green transition-colors drop-shadow-[0_0_12px_hsl(var(--neon-purple)/0.7)] hover:drop-shadow-[0_0_16px_hsl(var(--neon-green)/0.8)]"
            >
              SupremeCommerce
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
